import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import Icon from 'react-native-vector-icons/Feather';
import { Radius, Typography } from '../../theme';

/** Centered "Anna joined the chat" / "Anna left the chat" line in group chats. */
const MemberEventNotice: React.FC<{ label: string; joined: boolean }> = React.memo(({ label, joined }) => (
  <View style={styles.row}>
    <View style={styles.pill}>
      <Icon name={joined ? 'user-plus' : 'user-minus'} size={11} color={joined ? 'rgba(38,208,206,0.85)' : 'rgba(255,255,255,0.5)'} />
      <Text style={styles.text} numberOfLines={2}>{label}</Text>
    </View>
  </View>
));

export default MemberEventNotice;

const styles = StyleSheet.create({
  row: {
    alignItems: 'center',
    marginVertical: 8,
    paddingHorizontal: 24,
  },
  pill: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    paddingHorizontal: 12,
    paddingVertical: 5,
    borderRadius: Radius.pill,
    backgroundColor: 'rgba(255,255,255,0.06)',
  },
  text: {
    color: 'rgba(255,255,255,0.6)',
    fontSize: Typography.xs,
    fontWeight: Typography.semibold,
    textAlign: 'center',
  },
});
